var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"round-badge tw-shadow-md tw-border-[#CDFCB1] tw-border-[5px] text-white d-flex flex-column justify-content-center align-items-center align-items-center",class:[
    _vm.variant === 'BLOSSOM' ? 'round-badge__purple align-self-end' : '',
  ]},[_c('span',[_vm._v("Was $150, now")]),_c('span',{staticClass:"tw-text-6xl"},[_vm._v(" "+_vm._s(_vm.upsellPrice)+" ")]),_c('div',{staticClass:"text-center tw-mx-auto tw-font-atten-bold tw-mt-1 tw-text-md"},[_vm._v(" Galentine's Deal ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }